import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import {reorderElements} from "../../store/product/productElementsSlice";
import arrows from '../../../../assets/images/order_arrow.png';

const ElementReorderButtons = (props) => {
    const dispatch = useDispatch();
    const elements = useSelector(state => state.productElementsReducer.elements_with_selections);
    const elementsDisplayingOptions = useSelector(state => state.configuratorStateReducer.elementsDisplayingOptions);

    const shouldHide = (indexOffset) => {
        const elementsLength = elements.length;
        if(elementsLength == 1){
            return true;
        }
        switch(indexOffset){
            case -1:
                if(props.elementId === 0) {
                    return true;
                }
                break;
            case 1:
                if(props.elementId == elementsLength - 1) {
                    return true;
                }
                break;
        }
    }

    const disabled = (indexOffset) => {
        if(indexOffset === -1) {
            return !elementsDisplayingOptions.includes(props.elementId);
        } else if(indexOffset === 1) {
            return !elementsDisplayingOptions.includes(props.elementId + 1);
        }
    }

    const getArrow = (type) => {
        const arrowStyle = {
            backgroundImage: `url(${arrows})`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            height: '20px',
            width: '20px',
        }
        if(type == 'down'){
            arrowStyle.transform = 'rotate(180deg)';
        }
        return <div style={arrowStyle}></div>
    }

    const handleClick = (indexOffset) => {
        if(!disabled(indexOffset) || !props.disabled) {
            dispatch(reorderElements(props.elementId, indexOffset))
        }
    }

    return (<div style={{display: 'flex'}}>
        <span className={'button no-chevron ' + (shouldHide(-1) ? ' display-none ':'') + (disabled(-1) ? 'disabled ' : '') } style={{ padding: '10px', marginRight: '5px'}}  onClick={() => handleClick(-1)}>
            {getArrow('up')}
        </span>
        <span className={'button no-chevron ' + (shouldHide(1) ? ' display-none ':'') + (disabled(1) ? 'disabled ' : '')} style={{ padding: '10px', marginRight: '5px'}} onClick={() => handleClick(1)}>
            {getArrow('down')}
        </span>
    </div>)
}

export default ElementReorderButtons;